import PropTypes from 'prop-types';

const URL_PATTERN = /https?:\/\/[^\s<>"']+/gi;
const TRAILING_PUNCTUATION_PATTERN = /[.,!?;:]+$/;

const splitTrailingPunctuation = url => {
  const trailingPunctuation = (url.match(TRAILING_PUNCTUATION_PATTERN) || [
    '',
  ])[0];

  return {
    url: trailingPunctuation ? url.slice(0, -trailingPunctuation.length) : url,
    trailingPunctuation,
  };
};

function MessageContent({ content = '' }) {
  const parts = [];
  let lastIndex = 0;

  content.replace(URL_PATTERN, (match, offset) => {
    if (offset > lastIndex) {
      parts.push(content.slice(lastIndex, offset));
    }

    const { url, trailingPunctuation } = splitTrailingPunctuation(match);

    parts.push(
      <a
        key={`${url}-${offset}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {url}
      </a>,
    );

    if (trailingPunctuation) {
      parts.push(trailingPunctuation);
    }

    lastIndex = offset + match.length;
    return match;
  });

  if (lastIndex < content.length) {
    parts.push(content.slice(lastIndex));
  }

  return <>{parts}</>;
}

MessageContent.propTypes = {
  content: PropTypes.string,
};

export default MessageContent;
